<!-- <section class="contact-page">
  <div class="container">
    <div class="row mt-3">
      <div class="col-6 align-content-center">
        <div class="fontWeight600 fs-34px">
          <span>Contáctanos a cualquier hora y desde cualquier lugar</span>
        </div>
        <div class="mt-3 fs-16px">
          <span>Tienes soporte gratis e ilimitado para comunicarte con nuestro equipo especializado 24/7.
                ¡Dinos cómo podemos ayudarte!</span>
        </div>
      </div>
      <div class="col-6">
        <div class="card p-4">
          <div class="row">
            <div class="col-12 fs-20px fontWeight600">
              <span>¿Prefieres escribirnos? ¡Adelante!</span>
            </div>
            <div class="col-12 fs-14px">
              <span>Nuestro team especializado te responderá en el menor tiempo posible.</span>
            </div>
          </div>
          <div class="row mt-5">
            <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" novalidate>
              <div class="row">
                <div class="col-6">
                  <div class="form-group fs-14px">
                    <label for="name">Nombre completo*</label>
                    <input type="text" class="form-control form-control-sm fs-12px" id="name" 
                      formControlName="name" placeholder="Nombre" required [ngClass]="{'is-invalid': isInvalid('name')}">
                    <div *ngIf="isInvalid('name')" class="text-danger">
                      <small>Rellena este campo obligatorio.</small>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group fs-14px">
                    <label for="email">Correo electrónico*</label>
                    <input type="text" class="form-control form-control-sm fs-12px" id="email" 
                      formControlName="email" placeholder="Correo electrónico" required [ngClass]="{'is-invalid': isInvalid('email')}">
                    <div *ngIf="isInvalid('email')" class="text-danger">
                      <small>Rellena este campo obligatorio.</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group fs-14px mt-4">
                <span class="">¿En qué podemos ayudarte?*</span>
                <div class="form-check fs-14px mt-2">
                  <input class="form-check-input" type="radio" name="radioDefault" id="radioDefault1">
                  <label class="form-check-label" for="radioDefault1">
                    No tengo cuenta y quiero empezar a usar Centrix
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="radioDefault" id="radioDefault2" checked>
                  <label class="form-check-label" for="radioDefault2">
                    Soy contador y quiero empezar a usar Centrix
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="radioDefault" id="radioDefault2" checked>
                  <label class="form-check-label" for="radioDefault2">
                    Ya tengo cuenta y necesito ayuda
                  </label>
                </div>
              </div>
              <div class="form-group fs-14px mt-4">
                <span for="message">Cuéntanos más*</span>
                <textarea class="form-control form-control-sm fs-12px mt-2" rows="4" placeholder="Cuéntanos un poco más" id="message" 
                  formControlName="message" required [ngClass]="{'is-invalid': isInvalid('message')}"></textarea>
                <div *ngIf="isInvalid('message')" class="text-danger">
                  <small>Rellena este campo obligatorio.</small>
                </div>
              </div>
              <div class="mt-4">
                <button type="submit" class="btn-submit btn btn-sm d-flex align-items-center gap-2 py-2 px-3">Enviar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->

<div class="">
  <div class="header-container"></div>
</div>
<section id="contacto" class="contacto-section pt-1 pb-4">
  <div class="container py-5">
    <div class="row px-0 mx-0 align-items-center g-5">
      
      <div class="col-12 col-lg-5">
        <span class="badge bg-teal-soft text-teal mb-3 fs-18px">Contacto</span>
        <br/>
        <div class="display-5 fw-bold mb-1">¿Listo para digitalizar <span class="text-teal">tu empresa?</span></div>
        <br/>
        <div class="text-muted pt-1 pb-4">
          Completa el formulario y un asesor experto se pondrá en contacto contigo para ofrecerte la mejor solución en facturación, QR o ventas online.
        </div>
        
        <div class="d-flex flex-column gap-4">
          <div class="info-item d-flex align-items-center gap-3">
            <div class="icon-circle"><i class="fa-solid fa-location-dot"></i></div>
            <div>
              <p class="fw-bold m-0">Ubicación</p>
              <p class="text-muted m-0">Lima, Perú</p>
            </div>
          </div>
          <div class="info-item d-flex align-items-center gap-3">
            <div class="icon-circle"><i class="fa-solid fa-at"></i></div>
            <div>
              <p class="fw-bold m-0">Correo Electrónico</p>
              <p class="text-muted m-0">{{ emailContacto }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-7 px-2">
        <div class="card borderCard shadow-lg p-4 p-md-5 rounded-4">
          <form [formGroup]="contactoForm" (ngSubmit)="onSubmit()">
            <div class="row px-0 mx-0 g-3">
              <div class="col-12 col-md-6">
                <label class="form-label small fw-bold">Nombre Completo</label>
                <input type="text" formControlName="nombre" class="form-control" placeholder="Ej: Juan Pérez">
              </div>
              
              <div class="col-12 col-md-6">
                <label class="form-label small fw-bold">Documento de Identificación</label>
                <input type="text" formControlName="documento" class="form-control" placeholder="DNI o RUC">
              </div>

              <div class="col-12 col-md-6">
                <label class="form-label small fw-bold">Correo Electrónico</label>
                <input type="email" formControlName="correo" class="form-control" placeholder="ejemplo@empresa.com">
              </div>

              <div class="col-12 col-md-6">
                <label class="form-label small fw-bold">Teléfono / WhatsApp</label>
                <input type="tel" formControlName="telefono" class="form-control" placeholder="999 999 999">
              </div>

              <div class="col-12">
                <label class="form-label small fw-bold">Comentarios</label>
                <textarea formControlName="comentarios" class="form-control" rows="4" placeholder="Cuéntanos sobre tu proyecto..."></textarea>
              </div>

              <div class="col-12 mt-4">
                <button type="submit" [disabled]="contactoForm.invalid || enviando()" class="btn btn-teal w-100 py-3 fw-bold">
                  {{ enviando() ? 'Enviando...' : 'Enviar Mensaje' }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</section>